import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { UiThemeType } from "@webapp/ui/icon/icon.models";
import { UiModalRef } from "@webapp/ui/modal/abstracts/modal-ref";

@Component({
  selector: "confirm-action-modal",
  templateUrl: "confirm-action-modal.component.html",
  styleUrls: ["confirm-action-modal.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmActionModalComponent {
  @Input()
  public title: string;
  @Input()
  public description: string;
  @Input()
  public uiType?: string;
  @Input()
  public uiTheme?: UiThemeType = "outline";

  constructor(private modalRef: UiModalRef) {}

  public destroyModal(): void {
    this.modalRef.destroy();
  }
}
